import React, { useEffect } from "react";
import { useState } from "react";
import { validationFLFNotifyConfigInput } from "src/pages/FPTLife/utils/validateInput";
import Controls from "src/components/form/controls/Controls";
import { isDisableSubmit } from "src/utils";
import useForm, { Form } from "src/hooks/useForm";
import { getFLFCategory } from "src/apis/FLF/category.api";

const initialValue = {
  id: "",
  name: "",
  attrCode: 0,
  content: "",
  valueType: "",
  value: "",
  delay: 10,
  displayTime: 14,
  note: "",
  message: "",
  minValue: "",
  maxValue: "",
  flfCategoryId: "",
};

function FLFNotifyConfigForm(props) {
  const { addOrEdit, recordForEdit, errorsForm } = props;
  const [valueAddNew, setValueAddNew] = useState(initialValue);

  const [categories, setCategories] = useState([]);

  // validation input permission
  const validateFLFNotifyConfigForm = (fieldValues = values) => {
    let temp = validationFLFNotifyConfigInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateFLFNotifyConfigForm);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateFLFNotifyConfigForm()) {
      addOrEdit(values, resetForm);
      setValueAddNew(initialValue);
    }
  };

  useEffect(() => {
    // * Get list category

    getFLFCategory({}, (result) => {
      setCategories([...result.list]);
    });
  }, []);

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    } else {
      setValues({
        ...valueAddNew,
      });
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;
      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="name"
        value={values.name}
        label="Name"
        type="text"
        onChange={handleOnChange}
        error={errors.name}
      />

      <Controls.Input
        name="attrCode"
        value={values.attrCode}
        label="Attribute Code"
        type="number"
        onChange={handleOnChange}
        error={errors.attrCode}
      />

      <Controls.Select
        name="flfCategoryId"
        label="Category"
        value={values.flfCategoryId}
        onChange={handleOnChange}
        options={categories}
        searchable={true}
        error={Boolean(errors.flfCategoryId)}
      />

      <Controls.Input
        name="content"
        value={values.content}
        label="Content"
        type="text"
        onChange={handleOnChange}
        error={errors.content}
      />

      <Controls.Input
        name="valueType"
        value={values.valueType}
        label="Value Type"
        type="text"
        onChange={handleOnChange}
        error={errors.valueType}
      />

      <Controls.Input
        name="value"
        value={values.value}
        label="Value"
        type="text"
        onChange={handleOnChange}
        error={errors.value}
      />

      <Controls.Input
        name="minValue"
        value={values.minValue}
        label="Min Value"
        type="number"
        onChange={handleOnChange}
        error={errors.minValue}
      />

      <Controls.Input
        name="maxValue"
        value={values.maxValue}
        label="Max Value"
        type="number"
        onChange={handleOnChange}
        error={errors.maxValue}
      />

      <Controls.Input
        name="message"
        value={values.message}
        label="Message"
        type="text"
        onChange={handleOnChange}
        error={errors.message}
      />

      <Controls.Input
        name="delay"
        value={values.delay}
        label="Delay Time (s)"
        type="number"
        onChange={handleOnChange}
        error={errors.delay}
      />
      <Controls.Input
        name="displayTime"
        value={values.displayTime}
        label="Display Time (day)"
        type="number"
        onChange={handleOnChange}
        error={errors.displayTime}
      />

      <Controls.Input
        name="note"
        value={values.note}
        label="Note"
        type="text"
        minRows={3}
        multiline
        onChange={handleOnChange}
        error={errors.note}
      />

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={isDisableSubmit(recordForEdit, values)}
      />
    </Form>
  );
}

export default FLFNotifyConfigForm;
